/**
 * Assignment status canonical map.
 * Single source of truth for status labels and colors across the container
 * (drawer badge, status timeline, table cells, button transitions).
 */

export type AssignmentStatus =
    | 'new'
    | 'assigned_executor'
    | 'execution_started'
    | 'loading_started'
    | 'arrived_at_unloading'
    | 'unloading_started'
    | 'completed_by_driver'
    | 'completed_by_dispatcher'

export interface AssignmentStatusInfo {
    label: string
    color: string
}

export const ASSIGNMENT_STATUS_MAP: Record<AssignmentStatus, AssignmentStatusInfo> = {
    new: { label: 'Нова', color: '#8c8c8c' },
    assigned_executor: { label: 'Призначений виконавець', color: '#1890ff' },
    execution_started: { label: 'Розпочато виконання', color: '#13c2c2' },
    loading_started: { label: 'Розпочато завантаження', color: '#faad14' },
    arrived_at_unloading: { label: 'Прибув на розвантаження', color: '#722ed1' },
    unloading_started: { label: 'Розпочато розвантаження', color: '#eb2f96' },
    completed_by_driver: { label: 'Завершено водієм', color: '#a0d911' },
    completed_by_dispatcher: { label: 'Завершено диспетчером', color: '#52c41a' },
}
